import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { I18nModule } from '@foxeet/utils-modules';
import { IonicModule } from '@ionic/angular';
import { FormValidationMessagesModule } from '../../form-validation-messages/mobile/form-validation-messages.module';
import { FormCheckboxComponent } from './form-checkbox.component';

@NgModule({
  declarations: [FormCheckboxComponent],
  imports: [CommonModule, IonicModule, FormValidationMessagesModule, I18nModule.forChild(), ReactiveFormsModule],
  exports: [FormCheckboxComponent],
})
export class FormCheckboxModule {}
